// Utility function to get all leagues for a user
import { clearCookie } from './tokenManagement';  // Ensure you have this utility to clear the token
import API_BASE_URL from './apiConfig'; // Import API base URL

export const fetchUserLeagues = async (userId, token, navigate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/user/${userId}/leagues`, {
      method: "GET",
      credentials: "include",  // Ensure the cookies are sent with the request
    });

    if (response.status === 401) {  // Check if the server returns a 401 (unauthorized)
      const errorData = await response.json();
      if (errorData.message.includes("Token expired")) {  // Check for token expiry message
        clearCookie('authToken');  // Clear the token from cookies
        navigate('/createaccount');  // Redirect to the login page
      }
      throw new Error(errorData.message || "Unauthorized");
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch user leagues");
    }

    const data = await response.json();
    return data.leagues;
  } catch (error) {
    console.error("Error fetching user leagues:", error);
    throw error;  // Re-throw the error to propagate it to the calling function
  }
};
